import { render, staticRenderFns } from "./limitCustomers.vue?vue&type=template&id=59b8e081&scoped=true"
import script from "./limitCustomers.vue?vue&type=script&lang=js"
export * from "./limitCustomers.vue?vue&type=script&lang=js"
import style0 from "./limitCustomers.vue?vue&type=style&index=0&id=59b8e081&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b8e081",
  null
  
)

export default component.exports